export default __webpack_public_path__ + "static/media/icon-location.e3a53056.svg";